import { render, staticRenderFns } from "./EdenWrapper.vue?vue&type=template&id=475ff1dd&"
import script from "./EdenWrapper.vue?vue&type=script&lang=js&"
export * from "./EdenWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports